// extracted by mini-css-extract-plugin
export default {"cls1":"Link-cls1__d74109700bff83d0931e","cls2":"Link-cls2__c4115332004d99d0f81d Link-cls1__d74109700bff83d0931e"};